// Edge tokens on a square: the Green Street badge (top-left, under the terrain height label).
// TERRAIN 2 of 3: Sea Walls are no longer edge tokens — they sit on the board's edges
// (game.walls, drawn by EdgeWalls.jsx). The markers move clear of a wall on their side.
import { WALL_T, WALL_INSET } from "@/components/game/EdgeWalls";

export const WALL_KEYS = new Set(["low_sea_wall"]);
// Stage px a wall on `side` of the square takes from that edge (0 = no wall built there).
export const wallLift = (sides, side) => (sides?.has?.(side) ? WALL_INSET + WALL_T + 1 : 0);

function Badge({ testid, label, children, sides }) {
  return (
    <span
      role="img"
      aria-label={label}
      title={label}
      data-testid={testid}
      className="absolute flex items-center justify-center overflow-hidden"
      style={{ top: 18 + wallLift(sides, "top"), left: 6 + wallLift(sides, "left"), width: 20, height: 20, borderRadius: 10, background: "var(--card)", border: "1px solid var(--card-border)", pointerEvents: "auto" }}
    >
      {children}
    </span>
  );
}

// Green Street: a street tree on a green verge.
const GreenStreetIcon = () => (
  <svg width="13" height="13" viewBox="0 0 14 14" aria-hidden="true">
    <circle cx="7" cy="5.2" r="3.6" fill="#5E8F5A" />
    <rect x="6.2" y="7.8" width="1.6" height="4.2" rx="0.8" fill="#6b5540" />
    <rect x="2" y="12" width="10" height="1.4" rx="0.7" fill="#3E9A8C" />
  </svg>
);

// Green Street badge (top-left). `sides`: the sides of this square with a wall built on it.
export default function CellTokens({ tokens, sides = null }) {
  return (tokens || [])
    .filter((t) => !WALL_KEYS.has(t?.card_key))
    .map((t, i) => (
      <Badge key={t.card_id || i} testid={`edge-token-${t.card_key}-${i}`} label={t.card_name || "Green Street"} sides={sides}>
        <GreenStreetIcon />
      </Badge>
    ));
}
